import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showWarningMessage,
} from "../../../helper/message";
import { useGetCodeWiseAppModuleFeaturePermission } from "../../../helper/sessionHelper";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import Modal from "react-modal";
import { TextArea } from "devextreme-react";
import { Loader } from "../../Shared/PageLoader";

export default function ViewAssetMaterialMovementRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    remark: "",
    isAddRemarkModalOpen: false,
    actionTypeId: 0,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    remarkValidation: "",
  });
  const movementOrderfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission("MaterialMovementOrder");
  const materialRequestfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission("MATERIAL_MMR");
  const [
    assetMaterialMovementRequestInfo,
    setAssetMaterialMovementRequestInfo,
  ] = useState(null);
  const [assetMaterialMovementSubLst, setAssetMaterialMovementSubLst] =
    useState([]);
  const [assetMaterialMovementHistoryLst, setAssetMaterialMovementHistoryLst] =
    useState([]);
  const [isAssetMaterialMovementApproved, setIsAssetMaterialMovementApproved] =
    useState(false);
  const [
    isAssetMaterialMovementSendBackToDraft,
    setIsAssetMaterialMovementSendBackToDraft,
  ] = useState(false);
  const [isAssetMaterialMovementRollBack, setIsAssetMaterialMovementRollBack] =
    useState(false);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Movement Request Preview`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      await getAssetMaterialMovementRequestInfo(
        location?.state?.materialMrId,
        user?.userId
      );
      await getAssetMaterialMovementSubLst(location?.state?.materialMrId);
      await getAssetMaterialMovementHistoryLst(location?.state?.materialMrId);

      // setTimeout(async () => {
      //   await getAssetMaterialMovementRequestInfo(location?.state?.materialMrId,user?.userId);
      // }, 0);
      // setTimeout(async () => {
      //   await getAssetMaterialMovementSubLst(location?.state?.materialMrId);
      // }, 0);
      // setTimeout(async () => {
      //   await getAssetMaterialMovementHistoryLst(location?.state?.materialMrId);
      // }, 0);

      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetMaterialMovementRequestInfo = async (materialMrId, userId) => {
    try {
      const response = await assetService.getAssetMaterialMovementList(
        materialMrId,
        userId
      );
      setAssetMaterialMovementRequestInfo(response?.data[0] ?? null);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetMaterialMovementSubLst = async (materialMrId) => {
    try {
      const response = await assetService.getAssetMaterialMovementSub(
        materialMrId
      );
      setAssetMaterialMovementSubLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const isValidRemarkData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.remarkValidation = "";
      if (!state.remark) {
        isValid = false;
        err.remarkValidation = "Please enter remark.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnApproveAssetMaterialMovement = async (e) => {
    e.preventDefault();
    try {
      let workflowCategoryIdMr = 0;
      let categorybodyMr = {
        formId: materialRequestfeaturePermission?.featureId,
        projectId: assetMaterialMovementRequestInfo?.toProjectId ?? 0,
        departmentId: assetMaterialMovementRequestInfo?.departmentId ?? 0,
      };
      const categoryresponseMr = await assetService.getWorkflowGroup(
        categorybodyMr
      );
      if (categoryresponseMr?.data.length >= 1) {
        workflowCategoryIdMr = categoryresponseMr?.data[0].workflowCategoryId;
      }
      let workflowDataMr = await GetWorkFlowForApprovers(
        materialRequestfeaturePermission?.featureId,
        workflowCategoryIdMr,
        assetMaterialMovementRequestInfo?.toProjectId,
        assetMaterialMovementRequestInfo?.departmentId
      );
      const stagesWithApproversMr = workflowDataMr?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.map((stage) => ({
          actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
          approvers: stage?.approvers,
        }));
      const ApproversMr = workflowDataMr?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.flatMap((stage) =>
          stage?.approvers?.map((approver) => ({
            actionTypeId: stage?.actionTypeId,
            userId: approver?.userId,
            canEdit: approver?.canEdit,
            stageId: stage?.index,
          }))
        );
      let matchedStageMr = [];
      let highestStageItemsMr = [];
      let maxStageIdMr = 0;
      if (ApproversMr !== undefined) {
        maxStageIdMr = Math?.max(...ApproversMr?.map((item) => item.stageId));

        highestStageItemsMr = ApproversMr?.filter(
          (item) => item.stageId === maxStageIdMr
        );
        matchedStageMr = highestStageItemsMr?.filter(
          (e) => e.userId === user?.userId
        );
      }

      let workflowCategoryId = 0;
      let workflowData = [];
      if (matchedStageMr?.length > 0) {
        let categorybody = {
          formId: movementOrderfeaturePermission?.featureId,
          projectId: assetMaterialMovementRequestInfo?.toProjectId ?? 0,
          departmentId: assetMaterialMovementRequestInfo?.departmentId ?? 0,
        };
        const categoryresponse = await assetService.getWorkflowGroup(
          categorybody
        );
        if (categoryresponse?.data.length >= 1) {
          workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
        }
        workflowData = await GetWorkFlowForApprovers(
          movementOrderfeaturePermission?.featureId,
          workflowCategoryId,
          assetMaterialMovementRequestInfo?.toProjectId,
          assetMaterialMovementRequestInfo?.departmentId
        );
        // const stagesWithApprovers = workflowData?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.map((stage) => ({
        //     actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
        //     approvers: stage?.approvers,
        //   }));
        // const Approvers = workflowData?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.flatMap((stage) =>
        //     stage?.approvers?.map((approver) => ({
        //       actionTypeId: stage?.actionTypeId,
        //       userId: approver?.userId,
        //       canEdit: approver?.canEdit,
        //       stageId: stage?.index,
        //     }))
        //   );
        // let matchedStage = [];
        // let highestStageItems = [];
        // let maxStageId = 0;
        // if (Approvers !== undefined) {
        //   maxStageId = Math?.max(...Approvers?.map((item) => item.stageId));

        //   highestStageItems = Approvers?.filter(
        //     (item) => item.stageId === maxStageId
        //   );
        //   matchedStage = highestStageItems?.filter(
        //     (e) => e.userId === user?.userId
        //   );
        // }

        if (workflowData === null || workflowData === undefined) {
          await showErrorMessage(`Workflow not set for this category!!`);
          return;
        }
      }

      if (isValidRemarkData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to approve movement request?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setIsAssetMaterialMovementApproved(true);
        let workflowCategory = {};
        workflowCategory.formId = movementOrderfeaturePermission?.featureId;
        workflowCategory.categoryId = workflowCategoryId;
        workflowCategory.projectId =
          assetMaterialMovementRequestInfo?.toProjectId;
        workflowCategory.departmentId =
          assetMaterialMovementRequestInfo?.departmentId;

        let body = {
          materialMrId: location?.state?.materialMrId ?? 0,
          userId: user?.userId ?? 0,
          formId: location?.state?.formId ?? 0,
          remark: state.remark, //state.remark,
          departmentId: workflowData?.departmentId ?? 0,
          applicationId: 3,
          workflowId: workflowData?.id ?? 0,
          orderFormName: movementOrderfeaturePermission?.featureName,
          orderFormId: movementOrderfeaturePermission?.featureId,
          isLoginUserRequester:
            ApproversMr?.[0]?.actionTypeId === 8 ? false : true,
          workflowCategoryRequest: workflowCategory,
          isMatchedStage: matchedStageMr?.length > 0 ? true : false,
          statusId: Number(AssetSubStatus.AssetMaterialMovementApproved),
          isSentForApproval: false,
        };
        const response = await assetService.approveAssetMaterialMovementRequest(
          body
        );
        if (!response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showWarningMessage(response?.message);
          setIsAssetMaterialMovementApproved(false);
          setState((prev) => ({
            ...prev,
            isAddRemarkModalOpen: false,
          }));
          return;
        }
        isConfirmed = await showResponseMessage(response);
        setIsAssetMaterialMovementApproved(false);
        if (response?.isSuccess) {
          if (location?.state?.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else if (location?.state?.sourceUrl === "MaterialMovementRequest") {
            navigate("/MaterialMovementRequest");
          } else {
            navigate("/MyTasks");
          }
        }
      }
    } catch (error) {
      setIsAssetMaterialMovementApproved(false);
      console.log(error);
    }
  };

  const handleOnBackToNormalAssetMaterialMovement = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to send back to normal movement request?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setIsAssetMaterialMovementSendBackToDraft(true);
        const response =
          await assetService.sendBackToDraftAssetMaterialMovementRequest(
            location?.state?.materialMrId,
            user?.userId,
            location?.state?.formId,
            state.remark
          );
        if (!response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showWarningMessage(response?.message);
          setIsAssetMaterialMovementSendBackToDraft(false);
          setState((prev) => ({
            ...prev,
            isAddRemarkModalOpen: false,
          }));
          return;
        }
        isConfirmed = await showResponseMessage(response);
        setIsAssetMaterialMovementSendBackToDraft(false);
        if (response?.isSuccess) {
          if (location?.state?.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else {
            navigate("/MaterialMovementRequest");
          }
        }
      }
    } catch (error) {
      setIsAssetMaterialMovementSendBackToDraft(false);
      console.log(error);
    }
  };

  const handleOnRecallAssetMaterialMovement = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to recall movement request?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setIsAssetMaterialMovementRollBack(true);
        const response = await assetService.recallAssetMaterialMovementRequest(
          location?.state?.materialMrId,
          user?.userId,
          location?.state?.formId,
          state.remark
        );
        isConfirmed = await showResponseMessage(response);
        setIsAssetMaterialMovementRollBack(false);
        if (response?.isSuccess) {
          if (location?.state?.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else {
            navigate("/MaterialMovementRequest");
          }
        }
      }
    } catch (error) {
      setIsAssetMaterialMovementRollBack(false);
      console.log(error);
    }
  };

  const getAssetMaterialMovementHistoryLst = async (materialMrId) => {
    try {
      const response = await assetService.getAssetMaterialMovementHistoryList(
        materialMrId
      );
      setAssetMaterialMovementHistoryLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenAddRemarkModal = (actionTypeId) => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: true,
        actionTypeId: actionTypeId,
      }));
      let err = { ...errors };
      err.remarkValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAddRemarkModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: false,
        remark: "",
        actionTypeId: 0,
      }));
      setIsAssetMaterialMovementApproved(false);
      setIsAssetMaterialMovementSendBackToDraft(false);
      setIsAssetMaterialMovementRollBack(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card top-bottom" style={{ marginTop: "-10px" }}>
          <div className="card-body">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                if (location?.state?.sourceUrl === "MyTasks") {
                  navigate("/MyTasks");
                } else {
                  if (!location?.state?.isReport) {
                    navigate("/MaterialMovementRequest");
                  } else {
                    navigate("/ReportMaterialMovementRequest");
                  }
                }
              }}
            >
              <span title="Back ">
                <i className="fas fa-arrow-left" />
                &nbsp;&nbsp;Back
              </span>
            </button>
            {assetMaterialMovementRequestInfo?.isApproved && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  hidden={!props?.featurePermission?.canApprove}
                  onClick={() => {
                    handleOnOpenAddRemarkModal(1);
                  }}
                >
                  <span title="Approve">
                    <i className="fas fa-check" />
                    &nbsp;&nbsp;Approve
                  </span>
                </button>
              </>
            )}
            {assetMaterialMovementRequestInfo?.isSendBackToDraft && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    handleOnOpenAddRemarkModal(2);
                  }}
                  disabled={isAssetMaterialMovementSendBackToDraft}
                >
                  <span title="Back to Draft">
                    <i className="fas fa-check" />
                    &nbsp;&nbsp;Back to Draft
                  </span>
                </button>
              </>
            )}
            {assetMaterialMovementRequestInfo?.isRollBack && (
              <>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => {
                    handleOnOpenAddRemarkModal(3);
                  }}
                >
                  <span title="Recall">
                    <i className="fas fa-check" />
                    &nbsp;&nbsp;Recall
                  </span>
                </button>
              </>
            )}
            &nbsp;&nbsp;
            <button
              type="button"
              className="btn btn-primary btn-sm"
              hidden={!props?.featurePermission?.canPrint}
              onClick={() => {
                window.print();
              }}
            >
              <span title="Print">
                <i className="fas fa-print" />
                &nbsp;&nbsp;Print
              </span>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-9">
            <div className="card">
              <div className="card-body">
                <table width="100%" className="page-header">
                  <tr>
                    <td>
                      <div className="imglogo mt-2">
                        <img
                          src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png"
                          alt="DigilinkZ | Streamlining Storage, Access & Organization"
                          width="150"
                          className=""
                        />
                      </div>
                    </td>
                    <td align="right">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", color: "#282C7D" }}
                      >
                        Registered Office
                      </h6>
                      <p className="mb-0 pb-0 small">
                        8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                        Road No. 2, Banjara Hills, Hyderabad – 500034
                      </p>
                    </td>
                  </tr>
                </table>
                <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          MOVEMENT REQUEST
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {assetMaterialMovementRequestInfo?.materialMovementNo ??
                            ""}
                        </h6>
                      </td>
                    </tr>
                  </table>
                </div>
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    <tr>
                      <td width="150px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.fromName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.toName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Site</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.toProjectName ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Request No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.materialMovementNo ??
                          ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Note</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.note ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Date</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetMaterialMovementRequestInfo?.requestedDate
                          ? moment(
                              assetMaterialMovementRequestInfo?.requestedDate
                            )
                              ?.format(
                                DefaultDateFormat.MomentDisplayDateFormat
                              )
                              ?.toString()
                          : ""}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div className="message-body">
                  <DataGrid
                    dataSource={assetMaterialMovementSubLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={false}
                    height={300}
                  >
                    <Column
                      dataField="vendorName"
                      caption="Vendor"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="workOrderNo"
                      caption="Purchase No / Work Order No"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="materialDescription"
                      caption="Description"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="uomName"
                      caption="UOM"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="movementQuantity"
                      caption="Quantity"
                      allowSearch={true}
                      allowSorting={true}
                      alignment={"center"}
                    />

                    {/* <Column
                    dataField="totalCapacityOfMaterials"
                    caption="Total Capacity Of Materials"
                    allowSearch={true}
                    allowSorting={true}
                    alignment={"center"}
                  /> */}

                    <Column
                      dataField="remark"
                      caption="Remark"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="virtual" />
                    <SearchPanel
                      visible={false}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div className="list-group">
                  {assetMaterialMovementHistoryLst?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item?.statusName === "Recall"
                          ? "Recall Requested"
                          : item?.statusName}
                        &nbsp;by&nbsp;{item?.fullName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>
                          {item.remarkDate ?? ""}
                          {/* {item?.remarkDate
                            ? moment(item?.remarkDate)
                                ?.format(
                                  DefaultDateFormat.MomentDisplayDateFormat
                                )
                                ?.toString()
                            : ""} */}
                        </small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item?.remark}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetMaterialMovementRequestInfo?.assetMaterialMovementAttachment
              ?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetMaterialMovementRequestInfo?.assetMaterialMovementAttachment?.map(
                    (item, index) => (
                      <div className="list-group">
                        <div
                          key={index}
                          className="list-group-item list-group-item-action flex-column align-items-start"
                          style={{
                            borderBottom: "1px solid #cfcfcf",
                            marginBottom: "0.5rem",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <div className="d-flex w-100 justify-content-between align-items-center">
                            <small
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                window.open(item?.fileUrl, "_blank");
                              }}
                            >
                              {item?.fileName}
                              {/* item?.fileType */}
                            </small>
                            <small>{item?.fileSize} kb</small>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>

      {/* For Adding Remark (Approve/Back To Draft/Recall) */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAddRemarkModalOpen}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Adding Remark (Approve/Back To Draft/Recall)"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.actionTypeId === 1
              ? "Approval"
              : state.actionTypeId === 2
              ? "Send Back To Draft"
              : state.actionTypeId === 3
              ? "Recall"
              : ""}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  height={150}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Submit"
            onClick={async (e) => {
              if (state.actionTypeId === 1) {
                await handleOnApproveAssetMaterialMovement(e);
              } else if (state.actionTypeId === 2) {
                await handleOnBackToNormalAssetMaterialMovement(e);
              } else if (state.actionTypeId === 3) {
                await handleOnRecallAssetMaterialMovement(e);
              }
            }}
            disabled={
              state.actionTypeId === 1
                ? isAssetMaterialMovementApproved
                : state.actionTypeId === 2
                ? isAssetMaterialMovementSendBackToDraft
                : state.actionTypeId === 3
                ? isAssetMaterialMovementRollBack
                : false
            }
          >
            <span title="Submit">
              {state.actionTypeId === 1 ? (
                <>
                  <i
                    className={`fas fa-${
                      isAssetMaterialMovementApproved
                        ? `spinner fa-spin`
                        : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 2 ? (
                <>
                  <i
                    className={`fas fa-${
                      isAssetMaterialMovementSendBackToDraft
                        ? `spinner fa-spin`
                        : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 3 ? (
                <>
                  <i
                    className={`fas fa-${
                      isAssetMaterialMovementRollBack
                        ? `spinner fa-spin`
                        : `check`
                    }`}
                  />
                </>
              ) : null}
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
